import React from 'react';
import { StarsIcon } from '@newcore/icons';
import { Onboarding } from '@/features/onboarding/components/primitives';
import type { FactorType } from '@/features/onboarding/types/onboarding.types';
import { EnrolledFactorsList } from './enrolled-factors-list';

interface CompleteStepSuccessProps {
  userName?: string;
  enrolledFactors: FactorType[];
  onComplete: () => void | Promise<void>;
}

/**
 * Success state UI for CompleteStep
 * Shows congratulations message, enrolled factors, and button to continue
 */
export const CompleteStepSuccess: React.FC<CompleteStepSuccessProps> = ({
  userName,
  enrolledFactors,
  onComplete,
}) => {
  const displayName = userName?.split(' ')[0] ?? 'there';

  return (
    <div className='flex flex-col items-center text-center space-y-6 py-4'>
      <Onboarding.Icon className='h-20 w-20 bg-utility-green-100 text-utility-green-700 [&>svg]:h-10 [&>svg]:w-10'>
        <StarsIcon />
      </Onboarding.Icon>

      <Onboarding.Header>
        <Onboarding.Title>Congratulations, {displayName}!</Onboarding.Title>
        <Onboarding.Description>
          Your account is ready. Access your apps below.
        </Onboarding.Description>
      </Onboarding.Header>

      {enrolledFactors.length > 0 && (
        <EnrolledFactorsList factors={enrolledFactors} />
      )}

      <Onboarding.NextButton onClick={onComplete} className='w-full max-w-sm'>
        Go to My Apps
      </Onboarding.NextButton>
    </div>
  );
};
